import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';

import RichText, { fragment } from '../../../Core/RichText';
import Container from '../../../Core/Container';
import Link from '../../../Core/Link';

import { Wrapper, Content, Contact } from './styles';

const body = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <p>{children}</p>,
  },
};

const SimpleCTABanner = ({ data }) => {
  if (!data) return null;
  const { heading, headingStyle, bodyCopy, ctas } = data;

  const title = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => (
        <h2 className={headingStyle}>{children}</h2>
      ),
      [BLOCKS.HEADING_1]: (_, children) => (
        <h2 className={headingStyle}>{children}</h2>
      ),
      [BLOCKS.HEADING_2]: (_, children) => (
        <h2 className={headingStyle}>{children}</h2>
      ),
      [BLOCKS.HEADING_3]: (_, children) => (
        <h3 className={headingStyle}>{children}</h3>
      ),
    },
  };

  return (
    <Container as="section">
      <Wrapper>
        <Content>
          {heading && <RichText document={heading} options={title} />}
          {bodyCopy && <RichText document={bodyCopy} options={body} />}
        </Content>
        <Contact>
          {ctas &&
            ctas.map(cta => {
              if (cta.hideFrench === true) return null;
              return (
                <Link key={cta.id} data={cta}>
                  <RichText document={cta.label} options={fragment} />
                </Link>
              );
            })}
        </Contact>
      </Wrapper>
    </Container>
  );
};

SimpleCTABanner.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default SimpleCTABanner;
